import { Field } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';
import { SubjectJsonModel } from '../subject/subject.json.model';
import { ConsumerJsonModel } from '../consumer/consumer.json.model';
import { LearningSectionContainerJsonModel } from './learning-section-container/learning-section-container.json.model';
import { LearningUnitJsonModel } from '../learning-unit/learning-unit.json.model';
import { LearningSectionLayoutJsonModel } from './learning-section-layout/learning-section-layout.json.model';

export class LearningSectionJsonModel extends JsonApiModel {
  public static override readonly type = 'learning-sections';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public name!: string;

  @Field()
  public title!: string;

  @Field()
  public learningSectionType!: string;

  @Field()
  public showCopyright!: boolean;

  @Field()
  public version!: number;

  @Field()
  public learningUnits!: LearningUnitJsonModel[];

  @Field()
  public learningUnitIds!: string[];

  @Field({ toOne: LearningSectionLayoutJsonModel })
  public learningSectionLayout!: LearningSectionLayoutJsonModel;

  @Field({ toOne: ConsumerJsonModel })
  public consumer!: ConsumerJsonModel;

  @Field({ toMany: SubjectJsonModel })
  public subjects!: SubjectJsonModel[];

  @Field({ toMany: LearningSectionContainerJsonModel })
  public learningSectionContainers!: LearningSectionContainerJsonModel[];

  @Field()
  public subjectIds!: string[];
}
